import {
	AboutConfig,
	BackendService,
	FilterConfig,
	HeaderConfig,
	HistoryConfig,
	LegendConfig,
	MapConfig,
	MenuConfig,
	MoreConfig,
	SearchConfig,
	SearchService,
	SplashConfig,
	TermsConfig
}														from './';
import {
	AboutConfigProtocol,
  LegendConfigProtocol
}														from '../';
import { BehaviorSubject }	from 'rxjs';
import { Injectable }       from '@angular/core';

@Injectable()
export class ConfigService {
	mobile    = navigator.userAgent.indexOf('Phone')    !== -1 || (
              navigator.userAgent.indexOf('Android')  !== -1 &&
              navigator.userAgent.indexOf('Mobi')     !== -1);
  showMenu  = false;
  theme     = [ '#BBB', '#888', '#333' ];

	about:	  BehaviorSubject<AboutConfigProtocol>;
	filter:	  BehaviorSubject<FilterConfig>;
	header:	  BehaviorSubject<HeaderConfig>;
	history:	BehaviorSubject<HistoryConfig>;
	legend:	  BehaviorSubject<LegendConfigProtocol>;
	map:			BehaviorSubject<MapConfig>;
	menu:	  	BehaviorSubject<MenuConfig>;
	more:		  BehaviorSubject<MoreConfig>;
	search:	  BehaviorSubject<SearchConfig>;
	splash:	  BehaviorSubject<SplashConfig>;
	terms:		BehaviorSubject<TermsConfig>;

  get desktopClass(): string {
    return this.mobile ? '' : 'desktop';
  }

  get showMenuClass(): string {
    return this.showMenu ? 'menu' : '';
  } 

  constructor(private backendService: BackendService) {
		this.about		= new BehaviorSubject(new AboutConfig(this));
		this.filter		= new BehaviorSubject(new FilterConfig(this));
		this.header		= new BehaviorSubject(new HeaderConfig(this));
		this.history	= new BehaviorSubject(new HistoryConfig(this));
		this.legend		= new BehaviorSubject(new LegendConfig(this));
		this.map			= new BehaviorSubject(new MapConfig(this));
		this.menu			= new BehaviorSubject(new MenuConfig(this));
		this.more			= new BehaviorSubject(new MoreConfig(this));
		this.search		= new BehaviorSubject(new SearchConfig(this));
		this.splash		= new BehaviorSubject(new SplashConfig(this));
		this.terms		= new BehaviorSubject(new TermsConfig(this));
    
		backendService.getConfig(this.gotConfig, this);
    backendService.doorbellReady = this.doorbellReady;
		backendService.doorbellReadyContext = this;

    console.log('Config service created');
  }

  getColor(value: any, defaultValue: string): string {
		if (typeof value === 'string') {
			return value
		} else if (typeof value === 'number') {
			return this.theme[value]
		} else {
			return defaultValue
		}
	}

  getImage(value: string): string {
    return this.backendService.getImage(value);
  }

  gotConfig(config: any) {
		this.theme    = Array.isArray(config.theme) ? config.theme : this.theme;
    this.showMenu = typeof config.filter !== 'undefined' || typeof config.legend !== 'undefined';

		(<AboutConfig>this.about.value).update(config);
		this.filter.next(this.filter.value.update(config));
		this.header.next(this.header.value.update(config));
		this.history.next(this.history.value.update(config));
    (<LegendConfig>this.legend.value).update(config);
		this.map.next(this.map.value.update(config));
		this.menu.next(this.menu.value.update(config));
		this.more.value.update(config);
		this.search.next(this.search.value.update(config));
		this.splash.value.update(config);
		this.terms.value.update(config);
	}

  doorbellReady() {
    document.querySelector('legend').style.backgroundColor = this.theme[0];
    document.getElementById('doorbell-submit-button').style.backgroundColor = this.theme[1];
  }
}



// WEBPACK FOOTER //
// ./src/app/electraLib/service/config.service.ts